// Tiny registry so a mounted EditableNote's imperative editing API (defined
// in EditableNote.jsx, alongside its DOM/selection) can be reached from
// elsewhere in the tree — the note's own context menu — without plumbing
// props/refs through Canvas.jsx. One entry per currently-editing note; a note
// registers on mount and unregisters on unmount.
const editors = new Map();

export const registerNoteEditor = (api) => {
    editors.set(api.noteId, api);
};

export const unregisterNoteEditor = (noteId) => {
    editors.delete(noteId);
};

export const getNoteEditor = (noteId) => editors.get(noteId) || null;
